import { buildDownloadData } from '@/pages/intelligence/utils/commonUtils';
import { decimalFormat } from '@/pages/home/utils/common';
import { REGION_OPTIONS_CONFIG } from '@intelligence/components/RegionCountrySelector/config';
import { getMetricFilter } from '@/pages/intelligence/components/DownloadCommon/DownloadPage/utils';
import { getRegionCountryData } from '../../utils';
const XLIST = [
  'w&p overlap affinity',
  'w&w overlap affinity',
  'p&p overlap affinity',
  'p&w overlap affinity',
  'avg_playtime',
];
// const PLIST = ['wishlisted & play', 'wishlisted & wishlist', 'played & play', 'played & wishlist'];

const getFormatValue = (metric: string, value: any) => {
  if (XLIST.includes(metric)) {
    return Number(decimalFormat(value, 2, false, ''));
  }
  return value;
};

const getRegionValueName = (regionValue: any) => {
  return REGION_OPTIONS_CONFIG.find((item: any) => item.value === regionValue);
};

export function getPCConsoleSteamOverlapConfig(list: any, params: any, allParams: any) {
  // console.log('getPCConsoleSteamOverlapConfig-list', list);
  // console.log('getPCConsoleSteamOverlapConfig-params', params);
  // console.log('getPCConsoleSteamOverlapConfig-allParams', allParams);

  const config: any = {};
  const { regionOptions = [] } = allParams || {};
  const data = list?.rank_list || [];
  if (!data) {
    return;
  }

  // debugger;

  // 扁平化数据
  let items = [] as any[];
  data.forEach((item: any) => {
    const mp = {} as any;
    item?.metric_list?.forEach((m: any) => {
      if (!mp[m?.region]) {
        const cp = { ...item };
        items.push(cp);
        cp.download_region = m?.region;
        mp[m?.region] = cp;
      }
      // 散列指标
      mp[m?.region][`metrics_${m?.metric}`] = getFormatValue(m?.metric, m?.value);
      mp[m?.region][`metrics_value_${m?.metric}`] = m?.value;
    });
  });
  // 处理成list

  items = getMetricFilter(items, params);

  if (Array.isArray(items)) {
    // 4-segment 排序 key 映射
    const SEGMENT_SORT_KEY: Record<string, string> = {
      played_play: 'metrics_value_p&p overlap affinity',
      played_wishlist: 'metrics_value_p&w overlap affinity',
      wishlisted_play: 'metrics_value_w&p overlap affinity',
      wishlisted_wishlist: 'metrics_value_w&w overlap affinity',
    };
    items?.sort((a: any, b: any) => {
      if (a?.download_region !== b?.download_region) {
        return a?.download_region?.localeCompare(b?.download_region);
      }
      const sortKey = SEGMENT_SORT_KEY[segmentKey] || (
        params?.page_name === 'played'
          ? 'metrics_value_p&p overlap affinity'
          : 'metrics_value_w&p overlap affinity'
      );
      const left = a?.[sortKey] || 0;
      const right = b?.[sortKey] || 0;
      return right - left;
    });
  }

  // const targetList = Object.values(mp);
  // console.log('itemsListitemsList', items);

  // const itemsList = getMetricFilter(items, params);

  // 4-segment -> page_name 映射
  const SEGMENT_TO_PAGE_NAME: Record<string, string> = {
    played_play: 'played',
    played_wishlist: 'played',
    wishlisted_play: 'wishlisted',
    wishlisted_wishlist: 'wishlisted',
  };

  // 通过 metrics 推断当前 segment key
  const inferSegmentKey = (paramsObj: any): string => {
    const metrics = paramsObj?.metrics;
    if (Array.isArray(metrics)) {
      if (metrics.includes('p&p overlap affinity') && !metrics.includes('p&w overlap affinity')) return 'played_play';
      if (metrics.includes('p&w overlap affinity') && !metrics.includes('p&p overlap affinity')) return 'played_wishlist';
      if (metrics.includes('w&p overlap affinity') && !metrics.includes('w&w overlap affinity')) return 'wishlisted_play';
      if (metrics.includes('w&w overlap affinity') && !metrics.includes('w&p overlap affinity')) return 'wishlisted_wishlist';
    }
    // 回退到 page_name 判断
    return paramsObj?.page_name === 'wishlisted' ? 'wishlisted_play' : 'played_play';
  };

  const segmentKey = inferSegmentKey(params);
  const pageName = SEGMENT_TO_PAGE_NAME[segmentKey] || params?.page_name || 'played';

  // stat 页
  const statConfig = [
    {
      title: 'Game Name',
      key: (item: any) => item?.name || '',
    },
    {
      title: 'Publisher Company Name',
      key: (item: any) => item?.publisher || '',
      when: () => allParams?.company_show === 1,
    },
    {
      title: 'Publisher Company HQ Name',
      key: (item: any) => item?.publisher_addr_full_name || '',
      when: () => allParams?.company_show === 1,
    },
    {
      title: 'Publisher Parent Company',
      key: (item: any) => item?.parent_publisher || '',
      when: () => allParams?.company_show === 1,
    },
    {
      title: 'Developer Company Name',
      key: (item: any) => item?.developer || '',
      when: () => allParams?.company_show === 1,
    },
    {
      title: 'Developer Company HQ Name',
      key: (item: any) => item?.developer_addr_full_name || '',
      when: () => allParams?.company_show === 1,
    },
    {
      title: 'Developer Parent Company',
      key: (item: any) => item?.parent_developer || '',
      when: () => allParams?.company_show === 1,
    },
    {
      title: 'IEGG Main Genre',
      key: (item: any) => item?.iegg_genre || '',
      when: () => allParams?.genre_show === 1,
    },
    {
      title: 'IEGG Sub Genre',
      key: (item: any) => item?.iegg_sub_genre || '',
      when: () => allParams?.genre_show === 1,
    },
    {
      title: 'Steam Tag',
      key: (item: any) => {
        const tags = item?.steam_tag;
        if (Array.isArray(tags)) return tags.join(', ');
        return tags || '';
      },
      when: () => allParams?.steam_tag_show !== 0,
    },
    {
      title: 'Release Date',
      key: (item: any) => item?.release_time || '',
      when: () => allParams?.release_date_show === 1,
    },
    {
      title: 'Region_Chinese',
      key: (item: any) => getRegionValueName(item?.download_region)?.text_cn || '',
      when: () => params?.download_region_type === 'region',
    },
    {
      title: 'Region_English',
      key: (item: any) => getRegionValueName(item?.download_region)?.text_en || '',
      when: () => params?.download_region_type === 'region',
    },
    {
      title: 'Region_Chinese',
      key: (item: any) => {
        const regionCountryData = getRegionCountryData({
          regionMethod: 'region',
          options: regionOptions,
          code: item?.download_region,
        });
        return regionCountryData?.region_chinese || '';
      },
      when: () => params?.download_region_type === 'market',
    },
    {
      title: 'Region_English',
      key: (item: any) => {
        const regionCountryData = getRegionCountryData({
          regionMethod: 'region',
          options: regionOptions,
          code: item?.download_region,
        });
        return regionCountryData?.region_english || '';
      },
      when: () => params?.download_region_type === 'market',
    },
    {
      title: 'Country Name',
      key: (item: any) => {
        const regionCountryData = getRegionCountryData({
          regionMethod: 'market',
          options: regionOptions,
          code: item?.download_region,
        });
        return regionCountryData?.country_english || '';
      },
      when: () => params?.download_region_type === 'market',
    },
    {
      title: 'Country name in Abbreviation',
      key: (item: any) => item?.download_region || '',
      when: () => params?.download_region_type === 'market',
    },
    // ===== Played & Play segment =====
    {
      title: 'P&P Overlap Affinity(x)',
      key: (item: any) => item?.['metrics_p&p overlap affinity'] || '',
      when: () => segmentKey === 'played_play',
    },
    {
      title: 'Played&Play%',
      key: (item: any) => item?.['metrics_played & play'] || '',
      when: () => segmentKey === 'played_play',
    },
    {
      title: 'Average Playtime(h)',
      key: (item: any) => item?.metrics_avg_playtime || '',
      when: () => segmentKey === 'played_play',
    },
    // ===== Played & Wishlist segment =====
    {
      title: 'P&W Overlap Affinity(x)',
      key: (item: any) => item?.['metrics_p&w overlap affinity'] || '',
      when: () => segmentKey === 'played_wishlist',
    },
    {
      title: 'Played & Wishlist%',
      key: (item: any) => item?.['metrics_played & wishlist'] || '',
      when: () => segmentKey === 'played_wishlist',
    },
    // ===== Wishlisted & Play segment =====
    {
      title: 'W&P Overlap Affinity(x)',
      key: (item: any) => item?.['metrics_w&p overlap affinity'] || '',
      when: () => segmentKey === 'wishlisted_play',
    },
    {
      title: 'Wishlisted & Play%',
      key: (item: any) => item?.['metrics_wishlisted & play'] || '',
      when: () => segmentKey === 'wishlisted_play',
    },
    {
      title: 'Average Playtime(h)',
      key: (item: any) => item?.metrics_avg_playtime || '',
      when: () => segmentKey === 'wishlisted_play',
    },
    // ===== Wishlisted & Wishlist segment =====
    {
      title: 'W&W Overlap Affinity(x)',
      key: (item: any) => item?.['metrics_w&w overlap affinity'] || '',
      when: () => segmentKey === 'wishlisted_wishlist',
    },
    {
      title: 'Wishlisted & Wishlist%',
      key: (item: any) => item?.['metrics_wishlisted & wishlist'] || '',
      when: () => segmentKey === 'wishlisted_wishlist',
    },
  ];

  config.stat = {
    sheetName: params?.download_region_type === 'market' ? 'By Country' : 'By Region',
    style: 'normal',
    data: buildDownloadData(statConfig, items),
  };

  // 4-segment filter label 映射
  const SEGMENT_FILTER_LABELS: Record<string, string> = {
    played_play: 'Played&Play%',
    played_wishlist: 'Played&Wishlist%',
    wishlisted_play: 'Wishlisted&Play%',
    wishlisted_wishlist: 'Wishlisted&Wishlist%',
  };

  const metricFilterLabel = SEGMENT_FILTER_LABELS[segmentKey] || 'Played&Play%';
  const metricFilterObj = allParams?.metric_filter?.[0];

  // summary 直接用二维结果写
  const summaryData: any[][] = [
    ['Player Filter'],
    [
      '',
      'Region/Counties',
      allParams?.download_regions?.join(','),
    ],
    [
      '',
      ['played_play', 'played_wishlist'].includes(segmentKey) ? `${allParams?.gameName || ''} Playtime` : '',
      ['played_play', 'played_wishlist'].includes(segmentKey) ? (allParams?.engagement_level_a || '') : '',
    ],
    ['', 'Game B Playtime', allParams?.engagement_level_b || ''],
    ['Overlap Game Filter'],
    [
      '',
      metricFilterLabel,
      metricFilterObj ? `${metricFilterObj?.opt}${metricFilterObj?.value}%` : '',
    ],
  ];

  // Steam Tags 筛选条件
  const steamTags = allParams?.steam_tag || params?.steam_tag;
  if (Array.isArray(steamTags) && steamTags.length > 0) {
    const steamTagRelation = allParams?.steam_tag_relation || params?.steam_tag_relation || 'and';
    summaryData.push([
      '',
      'Steam Tags',
      `${steamTags.join(', ')} (${steamTagRelation.toUpperCase()})`,
    ]);
  }

  // IEGG Genre 筛选条件
  const ieggGenre = allParams?.iegg_genre_req || params?.iegg_genre_req;
  if (Array.isArray(ieggGenre) && ieggGenre.length > 0) {
    summaryData.push([
      '',
      'IEGG Genre',
      ieggGenre.join(', '),
    ]);
  }

  config.summary = {
    sheetName: 'Filter information',
    style: 'first col bold',
    data: summaryData,
  };

  return config;
}
